/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Batch_Discount_LabelInputs */

const es_admin_billing_batch_discount_label = /** @type {(inputs: Admin_Billing_Batch_Discount_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descuento`)
};

const en_admin_billing_batch_discount_label = /** @type {(inputs: Admin_Billing_Batch_Discount_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discount`)
};

/**
* | output |
* | --- |
* | "Discount" |
*
* @param {Admin_Billing_Batch_Discount_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_batch_discount_label = /** @type {((inputs?: Admin_Billing_Batch_Discount_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Batch_Discount_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_batch_discount_label(inputs)
	return en_admin_billing_batch_discount_label(inputs)
});
export { admin_billing_batch_discount_label as "admin.billing.batch.discount_label" }